import { Trans } from '@lingui/react';
import React from 'react';
import { useDispatch } from 'react-redux';

import {
    ModalVariants, openModal
} from '../../../../../../../../../app';
import { useHover } from '../../../../../../../../../hooks/use-hover';
import {
    ProfileImage,
    ProfileImageWrapper,
    MenuPopper,
    MenuPopperItem
} from './profile-picture.styled';
import { TeacherAdminIcon } from '@components';

type ProfilePictureProps = {
    profileImage: string | undefined
    handleRemoveProfileImage: () => void
};

export const ProfilePicture = ({
    handleRemoveProfileImage, profileImage
}: ProfilePictureProps) => {
    const dispatch = useDispatch();
    const [userProfilePictureRef, isUserProfilePictureHovered] = useHover();
    const openAddProfilePhotoModal = () => {
        dispatch(openModal({ variant: ModalVariants.profilePictureUpload }));
    };

    return (
        <ProfileImageWrapper ref={userProfilePictureRef}>
            {(profileImage) ?
                <ProfileImage src={profileImage} /> :
                <TeacherAdminIcon
                    icon={'profile'}
                />
            }
            <MenuPopper display={isUserProfilePictureHovered ? 'flex' : 'none'}>
                <MenuPopperItem data-testid={'add-profile-photo'} onClick={openAddProfilePhotoModal}>
                    <Trans id={'profile.addProfilePhoto'} />
                </MenuPopperItem>
                <MenuPopperItem data-testid={'remove-profile-photo'} onClick={handleRemoveProfileImage}>
                    <Trans id={'profile.remove'} />
                </MenuPopperItem>
            </MenuPopper>
        </ProfileImageWrapper>
    );
};
